import { HSCCard, HSCIcon } from 'Components';
import { AppContentView, AppFooter } from 'Components/AppLayout';
import { HSCButton } from 'Components/Buttons';
import { HELP_EMAIL, HELP_URL } from 'Config';
import styles from './Help.module.css';

const Help = () => {
  let helpLinkButton = (
    <HSCButton
      size={'large'}
      className={styles.link_button}
      minimal
      intent={'secondary'}
      href={HELP_URL}
      target={'_blank'}
      onMouseDown={(e) => e.preventDefault()}
      rel='noreferrer'
      buttonText={'BookStack Documentation'}
      tooltipText={'Go to the BookStack Documentation for BOS'}
      icon={<HSCIcon size={52} iconName={'book-marked'} />}
    />
  );

  const getEmailButton = (
    emailAddress,
    buttonText,
    subjectText,
    informationText,
  ) => {
    return (
      <div className={styles.help_box}>
        <div className={styles.help_info_text}>
          <HSCIcon
            className={styles.help_info_icon}
            style={{ paddingRight: 10, marginTop: 6 }}
            size={48}
            iconName={'question-comment'}
          />
          <div className={styles.questions_box}>
            {informationText.map((text, index) => (
              <span key={index}>{text}</span>
            ))}
          </div>
        </div>
        <HSCButton
          size={'large'}
          minimal
          intent={'secondary'}
          className={styles.email_link_button}
          href={`mailto:${emailAddress}?subject=${subjectText}`}
          icon={<HSCIcon iconName={'envelope'} size={30} />}
          tooltipText={buttonText}
          buttonText={buttonText}
        />
      </div>
    );
  };

  let emailLinkButton = getEmailButton(
    HELP_EMAIL,
    'Email the developers',
    'Help Needed with HSC Bio Resource Directory',
    [
      'Having problems with the BRD web application?',
      "Have you found a bug or a button that doesn't work?",
      'Did you reach an error page or receive an error message?',
    ],
  );

  return (
    <AppContentView hideBreadcrumbs title={'Help'} footer={<AppFooter />}>
      <HSCCard>
        <div className={styles.help_card}>
          {helpLinkButton}
          <div
            className={[
              styles.more_help_header,
              'text-3xl font-semibold font-industry mt-2',
            ].join(' ')}>
            Still need help?
          </div>
          {emailLinkButton}
        </div>
      </HSCCard>
    </AppContentView>
  );
};

export default Help;
